var windowW       = $(window).width();
var windowH       = $(window).innerHeight();
var _isSP         = false;
let _isTest       = false;

function videoControl(action,target){
  var $playerWindow = $(target)[0].contentWindow;
  $playerWindow.postMessage('{"event":"command","func":"'+action+'","args":""}', '*');
}

// preload
const preload = () =>{
  $(window).on('load' , function() {
    $("body").removeClass("preload");
  });
};

// checkSP
const checkSP = () =>{
  $(window).on('resize load' , function() {
    windowW       = $(window).width();
    if(windowW <= 767){
      _isSP = true;
    } else {
      _isSP = false;
    };
  });
};


//toggleHeader
const toggleHeader = () => {
  $(window).on("scroll", function(){
    var scrollPosition = $(window).scrollTop();
      if(scrollPosition >= 70){
        $("#st-Header").addClass('st-Header-Shorten');
      } else {
        $("#st-Header").removeClass('st-Header-Shorten');
      }
  });

};


//anchorLink
const anchorLink = () => {
  //ページ外からのページ内リンク
  var urlHash = location.hash;
  if(urlHash) {
      $('body,html').stop().scrollTop(0);
      setTimeout(function(){
          var target = $(urlHash);
          var position = target.offset().top - 80;
          $('body,html').stop().animate({scrollTop:position}, 500);
      }, 200);
  }

  //ページ内リンク
  $("a[href^='#']").on("click", function(){
    var linkSpeed    = 800;
    var linkHref     = $(this).attr("href");
    var linkTarget   = $(linkHref == "#" || linkHref == "" ? 'html' : linkHref);
    var linkAdjust   = 80;
    var linkPosition = linkTarget.offset().top;
    $("html, body").animate({scrollTop: linkPosition - linkAdjust}, linkSpeed, "easeInOutCubic");
    return false;
  });
};



//showMovie
const showMovie = () => {
  let trg = 0;
  let ticker = 0;

  $(window).on("load ", function() {
  });
  $('.movie-wrap_inner, .sw-Modal .close').on('click', function() {
    $(".sw-Modal").toggleClass("open");
    if(trg == 0) {
      videoControl("playVideo",'#youtube-modal');
      trg = 1;
    } else if(trg == 1) {
      videoControl("stopVideo",'#youtube-modal');
      trg = 0;
    }
  });
  $(window).on("scroll", function() {
    ticker ++;
    if (trg == 1 && ticker > 25) {
      $(".sw-Modal").removeClass("open");
      videoControl("stopVideo",'#youtube-modal');
      trg = 0;
    }
    setTimeout(function(){
      ticker = 0;
    }, 500);
  });
};



//toggleSidebar
const toggleSidebar = () => {
  let controller = new ScrollMagic.Controller();
  let scene01;
  let scene02;
  let flag = 0;
  $(window).on('load resize' , function() {
    if(_isSP == false) {
      let ltop = $('#column-news').offset().top;
      let rtop = $('#column-nav').offset().top;

      let ltopp = $('.idx-Main_Inner').offset().top + $('#column-news').outerHeight()-30;
      let rtopp = $('.idx-Main_Inner').offset().top + $('#column-nav').outerHeight()-30;

      let mainheight = $('.idx-Main_Inner').offset().top + $('.idx-Main_Inner').outerHeight();

      let ftop = $('.st-Footer').offset().top;

      let trgPos = ltop >= rtop ? ltop : rtop;
      let trgContentHeight = ltopp >= rtopp ? ltopp : rtopp;

      let rdur = ftop - rtopp;
      let ldur = ftop - ltopp;

      if(trgContentHeight >= mainheight){
        controller.destroy(true);
        $(".idx-Main").css("padding-bottom",0);
        let ftopmargin = mainheight - $('#st-Footer').offset().top;
        $(".idx-Main").css("height",trgContentHeight - 80);
        flag = 0;
      } else {
        if(flag == 1) {
          scene01.removePin(true);
          scene02.removePin(true);
          flag = 0;
        }
        $(".idx-Main").css("padding-bottom","");
        $(".idx-Main").css("height","");
        $("#pin-trigger").css("top",trgPos);
        scene01 = new ScrollMagic.Scene({triggerElement: "#pin-trigger",triggerHook: 0, duration: ldur})
                .setPin("#column-news")
                .addTo(controller);
        scene02 = new ScrollMagic.Scene({triggerElement: "#pin-trigger",triggerHook: 0, duration: rdur})
                .setPin("#column-nav")
                .addTo(controller)
        flag = 1;
      }
    } else {
      controller.destroy(true);
      $(".idx-Main").css("padding-bottom","");
      $(".idx-Main").css("height","");
    }
  });
}

//resizeHeader
const resizeHeader = () => {
  $(window).on("load scroll", function() {
    let scrollHeight = $(this).scrollTop();
    if (scrollHeight > 200) {
      $(".st-Header").addClass("scrolled");
    } else {
      $(".st-Header").removeClass("scrolled");
    }
    if (scrollHeight > 400) {
      $(".st-Pagetop").addClass("visible");
    } else {
      $(".st-Pagetop").removeClass("visible");
    }
  });
}


//toggleMenu
const toggleMenu = () => {
  $('.header-hamburger').on('click', function() {
    $(this).toggleClass("open");
    $(".header-nav").toggleClass("open");
  });
};

//toggleLoading
const toggleLoading = () => {
  $(window).on("load", function() {
    $(".st-Loading").addClass("loaded");
    setTimeout(function(){
      $(".idx-Col").addClass("loaded");
    },300);
  });
};

//resizeModal
const resizeModal = () => {
  $(window).on('resize load', function() {
    if (!matchMedia('(max-width: 798px)').matches) {
      let dispWdt = window.innerWidth;
      let dispHgt = window.innerHeight;
      if(dispHgt > dispWdt) {
        $(".sw-Modal_Inner .wrapper").addClass("resize");
      } else {
        $(".sw-Modal_Inner .wrapper").removeClass("resize");
      }
    }
  });
};

//paraBg
const paraBg = () => {
  $(window).on('load', function(){
    var contHeight = $(".st-Container").outerHeight();
    var scrollHeightL = "";
    var scrollHeightS = "";
    if (matchMedia('(max-width: 798px)').matches) {
      var scrollHeightL = (contHeight / 1500) * 75;
      var scrollHeightS = (contHeight / 1500) * 50;
    } else {
      var scrollHeightL = (contHeight / 1500) * 105;
      var scrollHeightS = (contHeight / 1500) * 65;
    }
    var controller = new ScrollMagic.Controller({vertical: true});
    var tween = new TimelineMax()
      .add([
            TweenMax.to("body", 1, {backgroundPosition: "center -="+scrollHeightL+"px, center -="+scrollHeightS+"px"}),
        ]);
    var scene = new ScrollMagic.Scene({triggerElement: "body", duration: contHeight, offset: 0})
      .setTween(tween)
      .addTo(controller);
    setTimeout(function(){
      $("body").addClass("loaded");
    }, 250);
  });
};

//timelineReset
const timelineReset = () => {
  let timer = 0;

  let ua = navigator.userAgent;
  if (/iPad|Macintosh/i.test(navigator.userAgent)&& 'ontouchend' in document || ua.indexOf('iPhone') > 0 || ua.indexOf('Android') > 0) {
    $(window).on('load orientationchange' , function() {
      if (timer > 0) {
         clearTimeout(timer);
      }
      timer = setTimeout(function () {
        $(".tl-wrap_inner").empty();
        $('.tl-wrap_inner').prepend('<a class="twitter-timeline" href="https://twitter.com/bang_dream_info?ref_src=twsrc%5Etfw" data-chrome="noheader nofooter transparent">Tweets by bang_dream_info</a>');
        twttr.widgets.load($(".tl-wrap_inner"));
      }, 1000);
    });
  } else {
    $(window).on('load resize' , function() {
      if (timer > 0) {
         clearTimeout(timer);
      }
      timer = setTimeout(function () {
        $(".tl-wrap_inner").empty();
        $('.tl-wrap_inner').prepend('<a class="twitter-timeline" href="https://twitter.com/bang_dream_info?ref_src=twsrc%5Etfw" data-chrome="noheader nofooter transparent">Tweets by bang_dream_info</a>');
        twttr.widgets.load($(".tl-wrap_inner"));
      }, 1000);
    });
  }
};

export {
  preload,
  checkSP,
  toggleHeader,
  showMovie,
  anchorLink,
  resizeHeader,
  toggleSidebar,
  toggleMenu,
  toggleLoading,
  resizeModal,
  paraBg,
  timelineReset
}



// WEBPACK FOOTER //
// ./src/popipa-movie_v1/assets/js/include/module.js